export default class SpecialOfferState {}
